import {createBrowserHistory} from 'history';

/**
 * Our own singleton History instance so we can push from outside components
 * rendered beneath the Router.
 */
export default createBrowserHistory();
